{
    "mask": {
        "boundsGroup": {
            "title": "Boundaries"
        },
        "generalGroup": {
            "hidden": "Hidden",
            "disabled": "Disabled"
        },
        "conditionsGroup": {
            "title": "Conditions",
            "requiredExpressions": "Require when",
            "disabledExpressions": "Disable when",
            "hiddenExpressions": "Hide when"
        },
        "requestPayloadGroup": {
            "title": "Request Payload",
            "contentType": "Content Type",
            "body": "Body",
            "textPlain": "Plain Text",
            "textCsv": "Spreadsheet (CSV)",
            "applicationJson": "Json Data",
            "applicationXWwwFormUrlencoded": "Form Data"
        },
        "validationGroup": {
            "title": "Validation",
            "required": "Required",
            "validationMinLength": "Min. Length",
            "validationMaxLength": "Max. Length"
        },
        "wflBehaviourGroup": {
            "title": "Layer",
            "description": "Description",
            "enabled": "Enabled"
        },
        "authProperty": {
            "method": "Auth Method",
            "methods": {
                "none": "None / Global",
                "basic": "Basic",
                "bearer": "Bearer"
            },
            "basicAuthUsername": "Username",
            "basicAuthPassword": "Password",
            "authorization": "Bearer Token"
        },
        "boundsProperty": {
            "width": "Width",
            "marginTop": "Margin Top",
            "marginRight": "Margin Right",
            "marginBottom": "Margin Bottom",
            "marginLeft": "Margin Left"
        },
        "datasourceProperty": {
            "title": "Datasource",
            "static": "Static",
            "source": "Datasource",
            "optionValue": "Value",
            "optionLabel": "Label"
        },
        "expressionsProperty": {
            "title": "Expressions",
            "operator": "Operator",
            "leftOperand": "Left Operand",
            "rightOperand": "Right Operand",
            "disjunctor": "Disjunctor"
        },
        "fieldNameProperty": {
            "title": "Field"
        },
        "floatingLabelProperty": {
            "title": "Floating Label"
        },
        "inputTypeProperty": {
            "title": "Type"
        },
        "labelProperty": {
            "title": "Label"
        },
        "nameProperty": {
            "title": "Name"
        },
        "objectProperty": {
            "typeOptions": {
                "string": "String",
                "number": "Number",
                "boolean": "Boolean",
                "json": "Json",
                "raw-string": "Raw String"
            },
            "value": "Value",
            "key": "Key",
            "type": "Type"
        },
        "pageNameProperty": {
            "title": "Page"
        },
        "placeholderProperty": {
            "title": "Placeholder"
        },
        "requiredProperty": {
            "title": "Required"
        },
        "slugProperty": {
            "title": "Slug"
        },
        "tagsProperty": {
            "title": "Tags",
            "placeholder": "Tags"
        },
        "validationContentTypeProperty": {
            "validationContentType": "Content Type",
            "validateContentTypeRegex": "Regex",
            "validateContentTypeRegexPlaceholder": "e.g. ^[a-z0-9]+$",
            "validateContentTypeDateBefore": "Before",
            "validateContentTypeDateBeforePlaceholder": "e.g. {{date \"now\"}}",
            "validateContentTypeDateAfter": "After",
            "validateContentTypeDateAfterPlaceholder": "e.g. {{date \"now\"}}",
            "validateContentTypeMessage": "Content Type Message"
        }
    }
}